<template>
  <div class="main-cont">
    <div class="coll-sel" v-if="userType === -1">
      <el-select v-model="deptId" placeholder="请选择学院" @change="deptChange">
        <el-option
          v-for="item in collegeList"
          :key="item.uuid"
          :label="item.deptName"
          :value="item.uuid"
        ></el-option>
      </el-select>
    </div>
    <div class="squ-view" v-if="blockNums">
      <div class="squ-item" v-for="item in basics" :key="item.val" @click="goToUserList(item)">
        <div class="item-top">{{ blockNums[item.val] || 0 }}</div>
        <div class="item-bott">{{ item.paramName }}</div>
      </div>
    </div>
    <growth :deptId="deptId" :userType="userType" />
    <mobilize :deptId="deptId" :userType="userType" />
  </div>
</template>

<script>
import { getItem } from "@/utils/storage";
import { topDeptList } from "@/api/dept";
import { findClassStatistics } from "@/api/user";
import Growth from "./growth.vue";
import Mobilize from "./mobilize.vue";

export default {
  name: "userData",
  components: {
    Growth,
    Mobilize,
  },
  data() {
    return {
      collegeList: [],
      deptId: "",
      userType: getItem("userType"),
      load: false,
      blockNums: {},
      basics: [
        { paramName: "注册用户数", val: "totalNum", query: { auditStatus : "2"} },
        { paramName: "考核用户数", val: "examNum",  query: { isExam : "1"} },
        { paramName: "退休用户数", val: "retireNum", query: { userStatus: "1" } },
      ],
    };
  },
  methods: {
    getNumAndType() {
      findClassStatistics({ deptId: this.deptId }).then(({ code, data }) => {
        if (code === 0) {
          this.blockNums = data;
        }
      });
    },
    deptChange(val) {
      this.deptId = val;
      this.getNumAndType();
    },
    initPage() {
      if (this.userType === -1) {
        topDeptList()
          .then(({ code, data }) => {
            if (code === 0) {
              this.collegeList = data;
              this.deptId = data[0].uuid;
              this.load = true;
              this.getNumAndType();
            }
          })
          .catch(() => {});
      } else {
        this.load = true;
        this.getNumAndType();
      }
    },
    goToUserList(item) {
      this.$router.push({ path: '/user', query: item.query });
    }
  },
  created() {
    this.initPage();
  },
};
</script>

<style lang="scss" scoped>
.main-cont {
  padding: 20px 24px;
  .coll-sel {
    margin-bottom: 30px;
  }
  .squ-view {
    display: flex;
    margin: 0 -8px;
    .squ-item {
      margin: 0 8px;
      flex: 1;
      height: 112px;
      text-align: center;
      background: #f5f7fc;
      &:hover {
        background: #ffffff;
        box-shadow: 0px 5px 11px 3px rgba(0, 0, 0, 0.05);
        border-radius: 6px;
      }
      .item-top {
        padding: 21px 0 5px 0;
        font-size: 32px;
        font-family: DIN-Medium, DIN;
        font-weight: 500;
        color: #343c4a;
        line-height: 39px;
      }
      .item-bott {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #51627d;
        line-height: 17px;
      }
    }
  }
}
</style>